<div class="container-fluid" >
  <div  style="display: inline;block-size: 10%;">
    <!--Header-->
    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 15px;">
        <div class="col-md-4 col-sm-6 lblHeader newHeader" style="display: inline-block;padding: 0px;">
          <h2 style="font-size: 25px;"> Material Availability</h2>
      </div>
      <div class="col-md-8 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
        <div class="checkbox" style="display: inline-block;" *ngIf="mtlHasTags">
          <label class="font13 chkbox-darkblue" (change)="toggleItemsTags();"
              style="margin-bottom: 0px !important; line-height: 30px; cursor: pointer;">
              <input type="checkbox" [(ngModel)]="showItemsTags" style="margin-right: 3px; position: relative; top: 1px;">
              Show Tags
          </label>
        </div>
        <span class="search" *ngIf="dataSource.data.length > 0">
          <span class="fa fa-search"></span>
          <input class="form-control brdrColor brdrRadius3" ng-model="search.term" placeholder="Search" matInput
            (keyup)="applyFilter($event)" #input
            style="text-align: left;display: inline-block; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 33px !important;"
            type="text">
        </span>
        <span *ngIf="exportToExcel.length > 0" (click)="exportToExcelActivities();" class="btn btn-orange brdrRadius3" style="margin-left: 10px; cursor: pointer;line-height: 22px; padding: 4px 10px;" title="Export to Excel">
          <span>
            <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
          </span>
        </span>

        <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
          <span class="btn-darkBlue brdrRadius3"
              style="font-size: 13px; display: inline-block; padding: 4px 12px 5px; margin-left: 10px;"
              (click)="backBtn()">
              <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
          </span>
        </div>
      </div>
    </div>
  </div>

  <!--Filter-->
  <div class="col-md-12 col-xs-12 col-sm-12" style="margin-bottom: 25px;display: inline-block;">
    <div style="display: inline-block">
      <div style="display: inline-block;">
        <span style="color: #15304a;vertical-align: middle; margin-right: 10px; font-size: 19px;"><i
            class="zmdi zmdi-widgets"></i></span>
      </div>
      <div style="display: inline-block; margin-right: 20px; cursor: pointer;">
        <select class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 350px; cursor: pointer;"
          [(ngModel)]="productList.prodID" (change)="ChangeProduct()" tabindex="1">
          <option value="0"> Select Product </option>
          <option *ngFor="let s of productListData" value="{{s.ItemID}}">{{s.ItemName}}</option>
        </select>
        <span style="position: absolute; bottom: -70%; left: 3%; font-size: 13px; color: grey;"> Please select a product to check availability.</span>
      </div>

    </div>  
      <div style="display:inline-block; margin-right: 15px">
        <div style="display: inline-block;">
          <label for="ShowAllLeads" class="fontSizeHead" style="font-size: 13px; display: inline-block; position:relative; cursor: pointer; font-weight: 500;">
            Qty : 
        </label>
        </div>
        <div style="display: inline-block;margin-left: 10px;">
            <input class="form-control bzInput bzInputPad" id="prdQty" placeholder="Qty" (keyup)="enterQty()" (blur)="prcnQty()" numbers_only [(ngModel)]="productList.qty" (keypress)="CmnService.numberOnly($event)" style="width: 100px; text-align: right;" tabindex="2" type="text">
        </div>
        <div style="display:inline-block; margin-left: 5px" *ngIf="productList.unitName != ''">
          <span style="display: inline-block; font-size: 13px; display: inline-block; position:relative; font-weight: 500;" class="ng-binding">{{productList.unitName}}</span>   
      </div>
      </div>

      <div style="display:inline-block; vertical-align: middle;">
          <span class="btn darkGreenButton brdrRadius3" style="padding: 4px 10px !important; font-size: 13px; line-height:20px" (click)="getData()"> Check</span>
      </div>
  </div>

  <!--Data Table-->
  <div class="wrapper" style="text-overflow: ellipsis; white-space: nowrap;"
    *ngIf="dataSource.data.length > 0" #mtlAviaTable>
    <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow brdrRadius3" style="width: {{showItemsTags ? '65%' : '50%'}};">
      <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px;">
      
          <ng-container matColumnDef="Material" style="cursor: pointer;">
      
          <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Material</label>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 25% !important;"> {{element.Material}} </td>
          </ng-container>
      
          <ng-container matColumnDef="PerUnitQty">
          <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Per Unit</label>
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.PerUnitQty}} </td>
          </ng-container>
      
          <ng-container matColumnDef="TotalNeededQty">
              <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Total Need</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.TotalNeededQty ? element.TotalNeededQty : '-'}} </td>
          </ng-container>

          <ng-container matColumnDef="StockQty">
              <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Stock</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.StockQty}} </td>
          </ng-container>

          <ng-container matColumnDef="ShortFallQty">
              <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Shortfall</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.ShortFallQty}} </td>
          </ng-container>
      
          <ng-container matColumnDef="Unit">
          <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label> Unit </label>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 7%;"> {{element.Unit}} </td>
          </ng-container>
          <ng-container matColumnDef="Tags">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label> Tags </label>
            </th>
            <td mat-cell *matCellDef="let element" style="width: 28%;"> {{element.Tags}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
      </table>
      <!-- Angular 8 pagination -->
      <mat-paginator [pageSizeOptions]="[10,20,30,40,50]" showFirstLastButtons style="border-radius: 3px;">
      </mat-paginator>
    </div>
  </div>
  
  <div *ngIf="materialAvailabilityList.length == 0">
    <div style="margin:15px" class="nrf brdrRadius3">No records found.</div>
  </div>
</div>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>